module.exports = __webpack_public_path__ + "img/done_check.65ff7626.svg";